import { useState, useEffect } from "react";
import nextIcon from './images/icons/next-arrow.svg';
import prevIcon from './images/icons/prev-arrow.svg';

const ImageSlider = ({ slides }) => {
    const [currentIndex, setCurrentIndex] = useState(0);
    const [myOpacity, setMyOpacity] = useState(1);
    const [touchStartX, setTouchStartX] = useState(null);
    const [touchEndX, setTouchEndX] = useState(null);

    const swipeThreshold = 50; // Minimum distance in px for swipe to trigger

    const prevSlide = () => {
        const isFirstSlide = currentIndex === 0;
        const newIndex = isFirstSlide ? slides.length - 1 : currentIndex - 1;

        animateFade(newIndex);
    };

    const nextSlide = () => {
        const isLastSlide = currentIndex === slides.length - 1;
        const newIndex = isLastSlide ? 0 : currentIndex + 1;

        animateFade(newIndex);
    };

    const animateFade = (newIndex) => {
        let start = null;
        const duration = 400;

        const fadeIn = (timestamp) => {
            if (!start) start = timestamp;
            const progress = timestamp - start;

            setCurrentIndex(newIndex);
            const newOpacity = Math.min(progress / duration, 1);
            setMyOpacity(newOpacity);

            if (progress < duration) {
                requestAnimationFrame(fadeIn);
            }
        };

        requestAnimationFrame(fadeIn);
    };

    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === 'ArrowRight') {
                nextSlide();
            } else if (event.key === 'ArrowLeft') {
                prevSlide();
            }
        };

        window.addEventListener('keydown', handleKeyDown);
        return () => window.removeEventListener('keydown', handleKeyDown);
    }, [currentIndex]);

    // Touch event handlers
    const handleTouchStart = (e) => {
        setTouchStartX(e.touches[0].clientX);
    };

    const handleTouchMove = (e) => {
        setTouchEndX(e.touches[0].clientX);
    };

    const handleTouchEnd = () => {
        if (!touchStartX || !touchEndX) return;

        const distance = touchStartX - touchEndX;

        if (distance > swipeThreshold) {
            nextSlide();
        } else if (distance < -swipeThreshold) {
            prevSlide();
        }

        setTouchStartX(null);
        setTouchEndX(null);
    };

    return (
        <div>
            <div
                className="slider"
                onTouchStart={handleTouchStart}
                onTouchMove={handleTouchMove}
                onTouchEnd={handleTouchEnd}
            >
                <div className="prev" onClick={prevSlide}>
                    <img src={prevIcon} height="50px" alt="Previous" />
                </div>
                <div className="next" onClick={nextSlide}>
                    <img src={nextIcon} height="50px" alt="Next" />
                </div>
                <img
                    src={slides[currentIndex].url}
                    style={{ opacity: myOpacity, transition: "opacity 0.4s ease" }}
                    alt={slides[currentIndex].alt}
                />
            </div>
        </div>
    );
};

export default ImageSlider;
